<template>
  <div >
    <div class="query-container">
      <div class="query-box">
          <div class="item-box" style="height:40px;">
            <router-link to="/order/new?type=shebao,gongjijin,ztax">
              <div class="flex">
                <div class="desc" style="display:table-cell;vertical-align:middle;">
                  <span class="title">缴社保</span>
                  <!-- <span class="slogan" >首月下单选周期</span> -->
                </div>
                <img class="icon" src="../assets/images/社保@2x.png" alt="">
              </div>
            </router-link>
          </div>
        <div style="height:40px;margin-top: 6px;" class="item-box">
          <router-link to="/order/new?type=gongjijin"> 
            <div class="flex">
              <div class="desc" style="display:table-cell;vertical-align:middle;">
                <span class="title">缴公积金</span>
                <!-- <span class="slogan">首月下单选周期</span> -->
              </div>
              <img class="icon" src="../assets/images/公积金@2x.png" alt="">
            </div>
          </router-link>
        </div>
      </div>
      <div class="query-box">
        <div class="item-box"  style="height:40px;">
          <router-link to="/order/list">
            <div class="flex">
              <div class="desc" style="display:table-cell;vertical-align:middle;">
              <span class="title">我的代缴</span>
                <!-- <span class="slogan">次月快捷续费</span> -->
              </div>
              <img class="icon" src="../assets/images/待支付.png" alt="" style="height: 36px; width: 36px;">
            </div>
          <div>
          </div>
          </router-link>
        </div>
        <div style="height:40px;margin-top: 6px; " class="item-box">
                    <router-link to="/order/list">
            <div class="flex">
              <div class="desc" >
                <span class="title">我要减员</span>
                <!-- <span class="slogan">减员即停止缴纳</span> -->
              </div>
              <img class="icon" src="../assets/images/减.png"   style="width: 36px;opacity: 0.7;" alt="">
            </div>
             </router-link>
           <div>
          </div>
        </div>
      </div>
    </div>
    <div class="query-container">
      <div  class="entry-item border-right">

        <a href="http://fuwu.rsj.beijing.gov.cn/csibiz/indinfo/login.jsp">
          <div>
            <img class="icon" src="../assets/images/社保查询.png" alt="">
            <div class="desc">
              <span class="title">社保查询</span>
            </div>
          </div>
        </a>
      </div>
      <div  class="entry-item border-right">
        
          <div @click="showGjjQrcode()">
            <img class="icon" src="../assets/images/公积金查询.png" alt="">
            <div class="desc">
              <span class="title">公积金查询</span>
            </div>
          </div>
      </div>
      <div class="entry-item border-right "  @click="more = !more">
      <img class="icon" src="../assets/images/更多.png" alt="">
        <div class="desc">
          <span class="title">{{more ? '收起':'更多'}}</span>
        </div>
      </div>
    </div>

    <div class="query-container">
      <div  class="entry-item border-right"  v-if="more">
        <a href="http://ybj.beijing.gov.cn/2020_zwfw/2020_bmcx/202002/t20200217_1644107.html">
          <div>
            <img class="icon" src="../assets/images/北京定点医院.png" alt="">
            <div class="desc">
              <span class="title">北京定点医院</span>
            </div>
          </div>
        </a>
      </div>
      <div  class="entry-item border-right"  v-if="more">
        <router-link to="/calculator?type=shebao">
          <div>
            <img class="icon" src="../assets/images/计算器社保.png" alt="">
            <div class="desc">
              <span class="title">社保计算器</span>
            </div>
          </div>
        </router-link>
      </div>
      <div  class="entry-item border-right" v-if="more">
        <router-link to="/calculator?type=gongjijin">
          <div>
            <img class="icon" src="../assets/images/计算器公积金.png" alt="">
            <div class="desc">
              <span class="title">公积金计算器</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>

     <div class="query-container">
      <div  class="entry-item border-right"  v-if="more">
        <a href="https://www.gerensuodeshui.cn/">
          <div>
            <img class="icon" src="../assets/images/个税计算器.png" alt="">
            <div class="desc">
              <span class="title">个税计算器</span>
            </div>
          </div>
        </a>
      </div>
      <div  class="entry-item border-right"  v-if="more">
        <router-link to="/calculator-cbj">
          <div>
            <img class="icon" src="../assets/images/参保金计算器.png" alt="">
            <div class="desc">
              <span class="title">残保金计算器</span>
            </div>
          </div>
        </router-link>
      </div>
     <div  class="entry-item border-right"  v-if="more">
       <a href="http://gjj.beijing.gov.cn/web/zwfw5/cyjsq/gjjdkjsq/index.html">
          <div>
            <img class="icon" src="../assets/images/贷款计算器.png" alt="">
            <div class="desc">
              <span class="title">公积金贷款计算器</span>
            </div>
          </div>
        </a>
      </div> 
      <div  class="entry-item border-right"  v-if="more">
        <a href="http://fuwu.rsj.beijing.gov.cn/integraltool/tool/simulation">
          <div>
            <img class="icon" src="../assets/images/积分.png" alt="">
            <div class="desc">
              <span class="title">积分落户计算器</span>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="blocked-box">
      <span>帮助</span>
    </div>
    <div class="help-container van-hairline--top-bottom" >
      <div class="query-box border-right">
       <router-link to="/read">
          <div class="desc">
            <span class="title">购买须知</span>
            <span class="slogan">购前先阅读本说明</span>
          </div>
          <img class="icon" src="../assets/images/购买须知.png" alt="">
       </router-link>
      </div>
      <div class="query-box">
        <router-link to="/how">
          <div class="desc">
            <span class="title">办理流程</span>
            <span class="slogan">代缴和服务流程</span>
          </div>
           <img class="icon" src="../assets/images/流程.png" alt="">

        </router-link>
      </div>
    </div>    
    <div class="blocked-box">
      <span>政策解读</span>
    </div>


    <div class="notice-box">
      <van-tabs >
        <van-tab  title="社保">
          <div class="media" v-for="item in shebaoNotices" :key="item.id"  @click="showNewsDetail(item)">
          <div class="media-left">
            <img class="media-object" :src="item.cover" alt="" />  
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{item.title}}</h4>
            <p class="longtext longtext-end" >{{item.desc}}</p>
          </div>
      </div>

  </van-tab>
    <van-tab  title="公积金">
       <div class="media" v-for="item in gongjijinNotices" :key="item.id"  @click="showNewsDetail(item)">
          <div class="media-left">
            <img class="media-object" :src="item.cover" alt="" />  
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{item.title}}</h4>
            <p class="longtext longtext-end" >{{item.desc}}</p>
          </div>
      </div> 
  </van-tab>
      <van-tab  title="个税">
       <div class="media" v-for="item in geshuiNotices" :key="item.id"  @click="showNewsDetail(item)">
          <div class="media-left">
            <img class="media-object" :src="item.cover" alt="" />  
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{item.title}}</h4>
            <p class="longtext longtext-end" >{{item.desc}}</p>
          </div>
      </div>  
      </van-tab>
</van-tabs>
    </div>
    <van-popup v-model="newsShow" class="news-pop ">
    <div class="news-pop-title"> {{newsItem.title}} </div>
        <div class="news-pop-img"> <img width="180" :src="newsItem.cover" alt="" />   </div>
    <div class="news-pop-desc" v-html="newsItem.desc">  </div>

    <van-button  size="small" style="width: 100%;" @click="newsShow=false">关闭</van-button>
    </van-popup>
    <van-popup v-model="gjjCodeShow" class="gjj-code-pop">
      <img src="https://open.weixin.qq.com/qr/code?username=gh_d7dfe024a186"/>
      <div>长按识别二维码关注「北京公积金」公众号查询</div>
    </van-popup>
    <van-dialog v-model="attritionDialog" id="search-dialog" :showConfirmButton="false">
          <van-list>
            <van-cell title="社保减员" @click="$router.push('/service/18')"/>
            <van-cell title="公积金减员" @click="$router.push('/service/19')"/>
          </van-list>
     </van-dialog>

     <span class="padding-top-10 block text-light-grey text-center text-tiny"><span>v0.0.59</span>--bv{{backendVersion}}<span></span></span>
  </div>
  
</template>

<script>
import {
  Swipe, SwipeItem, Lazyload,Row, Col, Tab, Tabs,Popup,Button,Dialog,Cell,List
} from "vant";
import Vue from 'vue';
Vue.use(Lazyload, {}).use(Swipe).use(SwipeItem).use(Row).use(Col).use(Popup).use(Button).use(Cell).use(List);

export default {
  props: ["message"],
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  name: "home",
  mounted: function(){
    this.$router.replace('/order/list');
    if (this.$route.query.s === '1') {
      this.attritionDialog = true
    }
    if (this.$route.query.s === '2') {
      this.$router.replace('/calculator?type=shebao')
    }

    this.$http.get('/api/common/version').then(res => {
      if (res) {this.backendVersion = res.data.data}
    })
 
  },
  methods: {
    showNewsDetail: function(item) {
      this.newsShow = true;
      this.newsItem = item;

    },
    showGjjQrcode: function() {
      this.gjjCodeShow = true
    },
    changeRadio: function(val) {
      console.log(val)
    }
  },
  data: function() {
    return {
      backendVersion: '',
      newsShow: false,
      gjjCodeShow: false,
      newsItem: {},
      attritionDialog: false,
      more: false,
      shebaoNotices: [
        {
          id: 1,
          cover: '/static/as/images/news/shebao-mf.png',
          title: '北京购房：连续缴纳5年社保',
          desc: "非京户籍，自购房之日起，往前推有连续5年，即60个月社保方可在京购房。因工作变动，在原单位或者现单位补缴不超过3个月社保，视为连续缴纳。"
        },
        {
          id: 2,
          cover: '/static/as/images/news/shebao-yh.png',
          title: '北京买车：连续缴纳5年社保+5年个税',
          desc: "非京户籍，自摇号之日起，往前推有连续5年，即60个月社保，并且同时具备连续5年个税，方可在京买车摇号。社保不能断月，断月补缴有效，个税可以断月，但不能断年，断年补缴无效。"
        },
        {
          id: 3,
          cover: '/static/as/images/news/shebao-school.png',
          title: '子女上学：连续缴纳3个月至3年社保',
          desc: "非京户籍，新生入学信息采集截止日之前，父母双方或一方在学校所属城区至少有3月-3年社保连续缴纳记录，各个城区对父母连续缴纳社保政策要求不同，以当年政策为准。",
        },
        // {
        //   id: 4,
        //   cover: 'http://p1.pstatp.com/large/4e6700048110a73ddab9',
        //   title: '生育津贴：连续缴纳一年社保',
        //   desc: "产前有连续9个月社保，且分娩当月加产后连续缴纳3个月社保，方可申领生育津贴。或者分娩当月正常缴纳，产后有连续12个月社保，也可申请生育津贴，同时可以报销产检和住院分娩费用。",
        // },
       
      ],
      gongjijinNotices: [
        {
          id: 10,
          cover: '/static/as/images/news/gongjijin-dk2.png',
          title: '公积金贷款：连续缴纳1年公积金',
          desc: "1、公积金账户至少有一年缴存记录，且申请当月往前推连续缴纳12个月公积金方可在京申请普通商品房公积金贷款。 <br/> 2、公积金账户至少有一年缴存记录，且申请当月往前推连续缴纳6个月公积金方可在京申请共有产权房等政策性房贷款。<br/> 3、连续缴纳6个月以上公积金，可以在外地购房并在当地申请公积金贷款，公积金缴纳时间视当地实际政策而定。"
        },
        {
          id: 11,
          cover: '/static/as/images/news/gongjijin-dk.png',
          title: '银行贷款和信用卡：连续缴纳1年公积金',
          desc: "在银行申请房贷、信用贷、经营贷或者信用卡时，具有公积金账户，并且缴存额度较高的，更容易审核通过。"
        }
      ],
      geshuiNotices: [
        {
          id: 20,
          cover: '/static/as/images/news/geshui-02.png',
          title: '北京购房：连续缴纳5年个税',
          desc: "非京户籍，自购房之日起，往前推有连续5年，即60个月个税方可在京购房，个税必须是工资报税。"

        },
        {
          id: 21,
          cover: '/static/as/images/news/shebao-yh.png',
          title: '北京买车：连续缴纳5年社保+5年个税',
          desc: "非京户籍，自摇号之日起，往前推有连续5年个税，劳务报税和工资报税方式均可，并且同时具备连续5年，即60个月社保，方可在京买车摇号。个税可以断月，但不能断年，断年补缴无效，社保不能断月，断月补缴有效。"
        },
        {
          id: 22,
          cover: '/static/as/images/news/shebao-jzz.png',
          title: '居住证：连续缴纳半年个税',
          desc: "非京户籍，办理人从申领当月的上上月往前推具备连续6个月纳税凭证。"
        }
      ],
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/var.less";
.tab-box {
  padding-bottom: 50px;
}
.image-containers {
  margin-top: 10px;
}
.news-box {
      padding: 8px;
    text-align: center;
    font-size: 13px;
    font-weight: 500;
}
.news-pop {
    width: 90%;
    z-index: 2009;
    border-radius: 5px;
    padding: 10px;
      text-align: center;

    .news-pop-title {
      font-weight: 500; 
    }
    .news-pop-img {
      margin-top: 11px;
    }
    .news-pop-desc {
          font-size: 14px;
    line-height: 25px;
    text-align: left;
    margin-bottom: 10px;
    margin-top: 10px;
    }
}


  .gift-box {
        padding-top: 15px;
    padding-bottom: 5px;
    flex: 1;
        background-color: white;
    margin-top: 10px;
  }


.gjj-code-pop {
  text-align: center;
      width: 90%;
      img {
        width: 100%;
      }
      div {

      font-size: 14px;
    padding-bottom: 15px;
      }
}

.media {
  background-color: @containBackColor;
  margin-top: 1px;
  padding: 10px;
  .media-object {
    width: 80px;
    height: auto;
    display: block;
    margin-right: 10px;
  }

  .media-body {
    overflow: hidden;
    zoom: 1;

    p {
      color: @defaultDescColor;
    }
  }

  .media-left, .media-body, .media-right {
    display: table-cell;
    vertical-align: top;
  }

  .media-heading {
    margin-top: 0px;
    margin-bottom: 5px;
  }

  h4 {
    font-size: 18px;
  }
}

.help-container {
  display: flex;
  margin-bottom: 1px;
  background-color: @containBackColor;

  .query-box {
    flex: 1;
    padding-left: 5px;
    padding-right: 5px;
    margin-bottom: 10px;
    margin-top: 10px;
    margin-left: 10px;

    &.border-right {
      border-right: 1px @borderColor solid;
    }
    .desc {
      display: inline-block;
      span {
        display: block;
      }
      text-align: left;
    }

    .title {
      font-size: 14px;
      color: #525252;
      margin-bottom: 10px;

      font-weight: bold;
      text-align: left;

    }

    .slogan {
      font-size: 12px;
      color: @defaultDescColor;
    }

    img.icon {
      width: 30px;
      height: auto;
      margin-left: 5px;
      margin-bottom: 5px;
      opacity: 0.6;
    }
  }
}

.blocked-box {
  background-color: white;
  padding: 10px;
  margin-top: 10px;

  span {
    margin: 0;
    padding: 0;
    text-align: center;
    font-size: 14px;
  }
  span:before {
    display: inline-block;
    padding: 0;
    margin-right: 5px;
    /* margin: 0 0 5px 5px; */
    height: 0.6em;
    content: " ";
    text-shadow: none;
    background-color: @defaultColor;
    width: 5px;
  }
}

.notice-box {
  
  .cover {
    background-color: white;
    padding: 5px;
    margin-top: 1px;

    img {
      max-width: 80px;
      width: auto;
      height: 60px;
      
    }

    .desc-box {
      display: inline-block;
      margin-left: 10px;
      span {
        margin-top: 5px;
        display: block;

        &.title {
          color: @defaultTitleColor;
          font-size: 14px;
        }
        &.desc {
          color: @defaultDescColor;
          font-size: 13px;
        
        }
      }
      text-align: left;
    }
  }

  .media {

    img {
      max-width: 80px;
      width: auto;
      height: 60px;
      
    }
    .media-body {
      h4 {
            font-size: 0.8rem;
        font-weight: normal;
      }
      p {
        font-size: 12px;
      }
    }
  }

}

.koubei-box {
  background-color: white;
  padding: 10px;
      padding-bottom: 1px;

  .avatar-box {
    display: block;
    .name {
      color: @defaultDescColor;
      font-size: 14px;
    line-height: 20px;
        position: relative;
    display: inline-block;
    
     img {
           width: 20px;
    border-radius: 10px;
        position: absolute;
    margin-right: 5px;
     }
     span {
           display: block;
    margin-left: 25px;
        line-height: 21px;
     }
    }
    .date {
      color: @defaultDescColor;
      font-size: 14px;
      float: right;
    }
  }

}
  .longtext {
    position: relative;
    line-height: 20px;
    max-height: 20px;
    overflow: hidden;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size:0.8rem;
  }
  .longtext-end::after {
    content: "...";
    position: absolute;
    bottom: 0;
    right: 0;
    padding-left: 40px;
  }
  .flex{
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 40px;
  }

  
</style>



// WEBPACK FOOTER //
// src/pages/home.vue